export const getFileType = mime => {
    if (mime?.includes('image')) {
        return 'image'
    } else if (mime?.includes('pdf')) {
        return 'pdf'
    } else {
        return mime
    }
}
